import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import {message} from "antd";
import $jq from "jquery";
import {config} from "./storyType-config"
import "./checkWord.css"
import {ArrayDuplication} from "../../../../utils";

/**
 * creat by tianruojun
 * @description 通用的安全中心预览页面，用来预览稿件详情的（兼容网站，微信，微博，快手）
 * @class SecurityPreview
 * @extends {BaseComponent}
 */
export default class SecurityPreview extends BaseComponent {
    static propTypes = {
    };
    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {
            checkAll: null,// 当前这条检测记录数据
            dataSource : null,// 当前稿件数据
            checkAllWord: [],// 最后一次检测记录的敏感词列表
            storyType: null, // 当前稿件类型配置
        }
    }

    componentWillMount() {
        // 读取路径参数
        this.readUrlParams();
        // 获取稿件类型
        this.getStoryType();
        // 读取敏感信息
        this.getCheckWord();
        // 读取当前稿件数据
        this.getStory();
    }

    componentDidMount() {
    }

    /**
     * 处理路径参数
     */
    readUrlParams = () => {
        if(this.urlParams) {
            this.state.checkAll = this.urlParams.checkAll;
        };
    };

    /**
     * 通过当前稿件的查询路径判断其稿件类型
     */
    getStoryType = () => {
        let url = this.state.checkAll?.data?.check_info_url;
        let storyType = {};
        if(url) {
            storyType = config.find(item=>url.indexOf(item.urlParams)>-1);
        }
        this.state.storyType = storyType;
        // this.setState({storyType})
    };

    /**
     * 获取敏感词列表
     */
    getCheckWord = () => {
        let checkAllWord = this.state.checkAll?.historyList?.[0]?.allWord || [];
        checkAllWord.sort((a,b)=>b.word.length-a.word.length);
        checkAllWord = ArrayDuplication(checkAllWord,'word');
        this.state.checkAllWord = checkAllWord
    };

    /**
     * 获取当前要预览的稿件数据
     */
    getStory = () => {
        let url = this.state.checkAll?.data?.check_info_url;
        if(url) {
            this.request({
                url,
                callBack: (dataSource)=>{
                    if(dataSource) {
                        this.setState({dataSource})
                    } else {
                        message.warning("获取稿件资源失败")
                    }
                },
                errorCallBack: (e)=>{
                    message.warning("获取稿件资源失败")
                }
            })
        } else {
            message.warning("数据路径丢失，无法获取稿件资源")
        }
    };

    /**
     * 添加敏感词鼠标悬浮效果
     */
    time = 0;
    throttleT = 100;
    throttle = (call) => {
        // let time = Date.now();
        // if(time-this.time>this.throttleT) {
        //     this.time = time;
        //     call&&call()
        // }
        setTimeout(()=>{
            call&&call()
        },100)
    };
    hoverText = () => {
        let details_content = $jq(".details_content");
        details_content.on('mouseover ', ".word", (e) => {
            console.log("'mouseenter'");
            this.throttle(()=>{
                this.enter(e)
            });
        });
        details_content.on('mousemove', ".word", (e) => {
            console.log("mousemove");
            this.throttle(()=>{
                this.move(e)
            });
        });
        details_content.on('mouseout', ".word,.itemCorrectWord", (e) => {
            console.log("mouseout");
            this.throttle(()=>{
                this.out(e)
            });
        });
        details_content.on('mouseleave ', ".word,.itemCorrectWord", (e) => {
            console.log("mouseleave");
            this.throttle(()=>{
                this.out(e)
            });
        });
    };

    move = (e) => {
        e.preventDefault();
        let dom = $jq(".itemCorrectWord");
        if(dom?.length) {
            let clientX = e.clientX;
            let clientY = e.clientY;
            dom.css("left",clientX);
            dom.css("top",clientY)
        } else {
            this.enter(e)
        }
    };

    enter = (e) => {
        e.preventDefault();
        let clientX = e.clientX-2;
        let clientY = e.clientY+2;
        var currWord = e.target.attributes.check.value;
        $jq('.itemCorrectWord').remove();
        let dome = '<span style="left:' + clientX + 'px;top:' + clientY + 'px  " class="itemCorrectWord">' +
            '<span></span>' +
            '<span>' + currWord + '</span>' +
            '</span>';
        $jq(".details_content").append(dome);
    };

    out = (e) => {
        e.preventDefault();
        $jq('.itemCorrectWord').remove()
    };

    render() {
        let Component = null;
        let {dataSource} = this.state;
        let component = this.state.storyType?.component;
        if(component && typeof component === "string") {
            try {
                Component = require(`./component/${component}/${component}`).default
            } catch (e) {
                console.log(e.toString())
            }
        }
        let dom = <div>数据加载错误</div>;
        if(Component) {
            if(dataSource) {
                dom = <Component
                    ref={ref=>{
                        // 给敏感词打标记
                        this.hoverText();
                    }}
                    {...this.state}
                />;
            } else {
                dom = "";
            }
        }
        return dom
    }

}